// @ts-nocheck

import B from 'bluebird';
import * as R from 'ramda';

import CustomPartnerService from '../../../../shared/CustomPartner.service';

// Using old store to blend in new redux store for now
import AppsStore from '../stores/AppsStore_LEGACY';
import MarketingStore from '../stores/MarketingStore';
import MainDispatcher from '../support/MainDispatcher';
import MarketingActions from './MarketingActions';
import NotificationActions from './NotificationActions';

import { updateAdLinks } from 'client/js/redux/domains/AdLinks/actions';

import debugLib from 'debug';
import moment from 'moment';
import { DEFAULT_LINK_STATE } from '../reducers/LinkCreatorReducer/utils';
import jsonp from '../support/JSONP';
import dash_api from '../support/dash_api';
import server from '../support/server';
import { ReduxAsyncAction, generateConstants } from '../support/utils';

// Retaining the search URL with the old iTunes domain- https://itunes.apple.com
// since the new domain https://apps.apple.com does not work for search and lookup
const ITUNES = {
  host: 'https://itunes.apple.com/',
  lookup: 'lookup',
  search: 'search',
  idRegex: /id([0-9]+)/g,
};

const debug = debugLib('LinkCreatorActions');
const ACTION_PREFIX = 'LINK_CREATOR';

/*
 * action types
 */
export const LINK_CREATOR = generateConstants(ACTION_PREFIX, ['processing']);

/**
 * shallow pune key if value is empty
 * @param  {Object} obj object to prune
 * @return {Object}     pruned object
 */
function shallowPruneEmpty(obj) {
  return R.pick(
    R.reject((x) => R.isNil(obj[x]), R.keys(obj)),
    obj
  );
}
/*
 * action creators
 */

/**
 * Action to get iOS app information
 * @param  {Object} payload
 * @param  {String} payload.appId   app id
 * @param  {String} payload.country country for your app, default is US
 * @return {Object} action
 */

export const GET_IOS_INFO = 'LINK_CREATOR_GET_IOS_INFO';
export function getIOSAppInfo({ appId, country = 'US' }) {
  return function getInfo(dispatch) {
    if (!appId) {
      debug('No appId to get ios app info');
      return;
    }
    const id = ITUNES.idRegex.exec(appId);
    if (id) {
      return jsonp(
        `${ITUNES.host}${ITUNES.lookup}`,
        {
          id: id[1],
          // prevent country is null
          country: country || 'US',
        },
        (e) => {
          const result = e.results[0];
          if (result) {
            debug(GET_IOS_INFO, result);
            dispatch({
              type: GET_IOS_INFO,
              data: result,
            });
          }
        }
      );
    }
  };
}

/**
 * get Android app info
 * @param  {Object} payload
 * @param  {String} payload.appId app id in google play
 * @return {Object} action
 */
const GetAndroidAppInfo = new ReduxAsyncAction('LINK_CREATOR_GET_ANDROID_INFO');
GetAndroidAppInfo.registerRequest(function ({ appId }) {
  return server('google play load', { value: appId });
});

export const GET_ANDROID_INFO = GetAndroidAppInfo.constants;
export const getAndroidAppInfo = GetAndroidAppInfo.request;

function addGoogleSecondaryFormatToLinkData(linkData) {
  if (linkData['~secondary_ad_format'] && linkData['~secondary_ad_format'].indexOf('Google') !== -1) {
    const { android_url, ios_url } = AppsStore.getApp();
    if (linkData['~secondary_ad_format'].indexOf('Android') !== -1) {
      linkData.$desktop_url = `https://play.google.com/store/apps/details?id=${android_url}&hl=en&referrer=google_search_install_referrer%3D<link_id>`;
    } else {
      linkData.$desktop_url = `https://apps.apple.com/us/app/${ios_url}`;
    }
  }
  return linkData;
}

/**
 * Saves an Ad link
 * @param  {Object} payload link data
 * @return {Object} action
 */
function saveAdLink(payload, dispatch) {
  if (!payload) {
    debug('No data passed in as payload, abort');
    return;
  }
  const { use_custom_domain_for_ad_link } = window.App.context.flipper;
  const formattedLink = R.pick(Object.keys(DEFAULT_LINK_STATE), payload);
  formattedLink.data = shallowPruneEmpty(payload.data);

  // need $desktop_url in link data for Google secondary ad format
  formattedLink.data = addGoogleSecondaryFormatToLinkData(formattedLink.data);
  const useCustomDomain =
    use_custom_domain_for_ad_link && formattedLink.data.$3p && formattedLink.data.$3p === 'a_google_adwords';
  debug('Saving Ads link: ', formattedLink);
  return dash_api
    .post('/v1/link-creator/ads', {
      link_id: formattedLink.link_id,
      link: formattedLink,
      use_custom_domain: useCustomDomain,
    })
    .then((res) => {
      // TODO: have ad network service return template id and make clear the difference
      // currently returning only the link id. Very confusing naming right now
      res.data.link_id = formattedLink.link_id;

      dispatch(updateAdLinks(res.data));

      return res.data;
    });
}

/**
 * Saves a link
 * @param {Object}  payload link data
 * @param {String}  type    link type
 * @return {Object} action
 */
const SaveLink = new ReduxAsyncAction('LINK_CREATOR_SAVE_LINK');
SaveLink.registerRequest(function (payload, type) {
  if (type === 'ADS') {
    return saveAdLink(payload, this.dispatch);
  }

  const formattedLink = R.pick(Object.keys(DEFAULT_LINK_STATE), payload);
  formattedLink.data = shallowPruneEmpty(payload.data);

  const formData = new FormData();

  formData.append('link', JSON.stringify(formattedLink));
  formData.append('og_image', payload.image);

  debug('Saving link', formattedLink, payload.data);

  return dash_api
    .post('/v1/link/marketing', formData, {
      headers: {
        'content-type': 'multipart/form-data',
      },
    })
    .then(({ data }) => {
      debug('Data return', data);

      // TODO, temp to update old store
      if (!!MarketingStore.getLink('find', data.id)) {
        // Edit mode: Data already loaded
        MarketingActions.updateLocally(data);
      } else {
        // new link
        MainDispatcher.dispatch({
          action: 'MARKETING_SAVED',
          link_id: data.link_id,
          link: data,
        });
      }

      return data;
    });
});

SaveLink.showProgressBar();
export const SAVE_LINK = SaveLink.constants;
export const saveLink = SaveLink.request;

/**
 * Update link data to store
 * @param  {Object}  data        data to update
 * @param  {Boolean} forceUpdate to force override the value instead of merging
 * @return {Object}  action
 */
export const UPDATE_LINK = 'LINK_CREATOR_UPDATE';
export function updateLinkData(data, forceUpdate) {
  debug(UPDATE_LINK, data, forceUpdate);
  return {
    type: UPDATE_LINK,
    data,
    forceUpdate,
  };
}

/**
 * Loads an Ad link using a link id
 * @param  {Object} payload
 * @param  {String} payload.linkId
 * @param  {Bool}   payload.isClone
 * @return {Object} action
 */
function getAdsLinkById({ linkId, isClone, links }) {
  // first check for link in ad_links store if available
  if (links && !R.isEmpty(links)) {
    const link = R.find(R.propEq('id', linkId), links);
    if (link) {
      return B.resolve({
        link_type: 'ad',
        isClone,
        link,
      });
    }
  }

  return dash_api.get(`/v1/link-creator/ads/${linkId}`).then((payload) => {
    const { data } = payload;
    return {
      isClone: isClone,
      link: data,
      link_type: 'ad',
    };
  });
}

const GetAllLinks = new ReduxAsyncAction('LINK_CREATOR_GET_ALL_LINKS');
GetAllLinks.registerRequest(function () {
  return dash_api
    .get('/v1/link/marketing')
    .then(({ data: allLinks }) => {
      return { allLinks };
    })
    .catch((err) => {
      debug(err);
      NotificationActions.entityError('Error fetching quick links');
    });
});
export const GET_ALL_LINKS = GetAllLinks.constants;
export const getAllLinks = GetAllLinks.request;

/**
 * Loads a link using a link id
 * @param  {Object} payload
 * @param  {String} payload.linkId
 * @param  {Bool}   payload.isClone
 * @return {Object} action
 */
const GetLinkById = new ReduxAsyncAction('LINK_CREATOR_GET_LINK');
GetLinkById.registerRequest(function (payload, type, links) {
  const { linkId, isClone } = payload;

  debug(`Get ${type} link: `, linkId);
  if (type === 'ADS') {
    return getAdsLinkById({ linkId, isClone, links });
  }

  const resultObject = {
    isClone: isClone,
    link_type: 'marketing',
  };

  const marketingLink = MarketingStore.getLink('edit', linkId);
  if (marketingLink) {
    return B.resolve(
      Object.assign({}, resultObject, {
        link: marketingLink,
      })
    );
  } else {
    return MarketingActions.loadOne(linkId)
      .then(() => {
        return Object.assign({}, resultObject, {
          link: MarketingStore.getLink('edit', linkId),
        });
      })
      .catch(() => {
        return resultObject;
      });
  }
});

GetLinkById.showProgressBar();
export const GET_LINK = GetLinkById.constants;
export const getLinkById = GetLinkById.request;

/**
 * Rest all store state
 * @return {Object} action
 */
export const RESET_STORE = 'LINK_CREATOR_RESET';
export function resetStore() {
  debug(RESET_STORE);
  return {
    type: RESET_STORE,
    app: AppsStore.getApp(),
  };
}

/**
 * Clear scraper data
 * @return {Object} action
 */
export const CLEAR_SCRAPER_DATA = 'LINK_CREATOR_CLEAR_SCRAPER_DATA';
export function clearScraperData() {
  debug(CLEAR_SCRAPER_DATA);
  return {
    type: CLEAR_SCRAPER_DATA,
    app: AppsStore.getApp(),
  };
}

/**
 * Fetches top data for a given dimension from druid
 * @param  {String} type     campaign or channel
 * @param  {String} endpoint topcampaign or topchannel
 * @return {Object} action
 */
function getTopData(type, endpoint) {
  debug(`get top ${type}`);
  const end = moment().format();
  const start = moment().subtract(3, 'months').format();

  return dash_api
    .post(`/v1/marketing/${endpoint}`, {
      start_time: start,
      end_time: end,
    })
    .then(R.prop('data'));
}

/**
 * Fetch top channel names
 * @param  {Object} payload
 * @return {Object} action
 */
const GetTopChannel = new ReduxAsyncAction('LINK_CREATOR_GET_TOP_CHANNEL');
GetTopChannel.registerRequest(function () {
  return getTopData('channel', 'topchannel');
});

export const GET_TOP_CHANNEL = GetTopChannel.constants;
export const getTopChannel = GetTopChannel.request;

/**
 * Fetch top campaign names
 * @param  {Object} payload
 * @return {Object} action
 */
const GetTopCampaign = new ReduxAsyncAction('LINK_CREATOR_GET_TOP_CAMPAIGN');
GetTopCampaign.registerRequest(function () {
  return getTopData('campaign', 'topcampaign');
});

export const GET_TOP_CAMPAIGN = GetTopCampaign.constants;
export const getTopCampaign = GetTopCampaign.request;

/**
 * Fetch top feature names
 * @param  {Object} payload
 * @return {Object} action
 */
const GetTopFeature = new ReduxAsyncAction('LINK_CREATOR_GET_TOP_FEATURE');
GetTopFeature.registerRequest(function () {
  return getTopData('feature', 'topfeature');
});

export const GET_TOP_FEATURE = GetTopFeature.constants;
export const getTopFeature = GetTopFeature.request;

/* TODO: use the ad_partner actions and store for getEnabledAdNetworks and getAdOntology */

/**
 * Fetch global network configs and check if enabled by app
 * @param  {Object} payload
 * @return {Object} action
 */
const GetEnabledAdNetworks = new ReduxAsyncAction('LINK_CREATOR_GET_ENABLED_NETWORKS');
GetEnabledAdNetworks.registerRequest(function () {
  var enabledNetworks = [];

  return dash_api
    .get(`/v1/ad-networks/app`)
    .then((app_payload) => {
      const { data } = app_payload;

      enabledNetworks = data;

      debug('Enabled networks list: ', enabledNetworks);
      return dash_api.get('/v1/ad-networks/global');
    })
    .then((global_payload) => {
      const { data } = global_payload;

      var networks = R.map((network) => {
        var enabled = enabledNetworks[network.machine_name] && enabledNetworks[network.machine_name].enabled;

        return R.assoc('enabled', !!enabled, network);
      }, data);
      const customNetworks = R.pickBy((network) => CustomPartnerService.isCustomPartner(network), enabledNetworks);
      networks = networks.concat(Object.keys(customNetworks).map((network) => customNetworks[network]));
      const sortedNetworks = R.sort((a, b) => b.enabled - a.enabled, networks);
      debug('Enabled network configs: ', sortedNetworks);
      return sortedNetworks;
    });
});

export const GET_ENABLED_NETWORKS = GetEnabledAdNetworks.constants;
export const getEnabledAdNetworks = GetEnabledAdNetworks.request;

/**
 * Fetch advertising_ontology
 * @return {Object} action
 */
const GetAdOntology = new ReduxAsyncAction('LINK_CREATOR_GET_AD_ONTOLOGY');
GetAdOntology.registerRequest(function () {
  const data = dash_api.get(`/v1/ad-networks/ontology`).then(R.prop('data'));

  return data;
});

export const GET_AD_ONTOLOGY = GetAdOntology.constants;
export const getAdOntology = GetAdOntology.request;

const GetQuickLinkTemplate = new ReduxAsyncAction('LINK_CREATOR_GET_QLT');
GetQuickLinkTemplate.registerRequest(function (id) {
  return dash_api.get(`/v1/linkhub/quick-link-templates/${id}`).then(({ data }) => {
    return data;
  });
});

export const LINK_CREATOR_GET_QLT = GetQuickLinkTemplate.constants;
export const getLinkCreatorQuickLinkTemplate = GetQuickLinkTemplate.request;

export const UPDATE_TEMPLATE_VALIDATION_STATUS = 'UPDATE_TEMPLATE_VALIDATION_STATUS';
export function updateTemplateValidationStatus(property: string, valid: boolean) {
  return {
    type: UPDATE_TEMPLATE_VALIDATION_STATUS,
    property: !valid ? '' : property,
    status: Array.isArray(valid) ? valid.length > 0 : !!valid,
  };
}

export const REMOVE_LINK_DATA_PROPERTY = 'REMOVE_LINK_DATA_PROPERTY';
export function removeLinkDataProperty(linkDataKey: string) {
  return {
    type: REMOVE_LINK_DATA_PROPERTY,
    linkDataKey: linkDataKey,
  };
}
